module.exports = "<sq-unauthorized></sq-unauthorized>\n";